import IconButton from "@pathwright/ui/src/components/button/IconButton"
import { ConnectStores } from "lib/core/store"
import { LEARN } from "path/constants"
import "./LessonNav.css"

const LessonNav = function (props) {
  const { resource, pathURL, mode, setMode, isNext } = props

  let headline = resource.name
  if (isNext && mode <= LEARN) {
    headline = `Up next in ${headline}`
  }

  return (
    <nav className="LessonNav">
      <div className="LessonNav__title">
        <h1>{headline}</h1>
      </div>
      <IconButton
        className="StepSequenceNav__back"
        icon="x"
        to={pathURL}
        size={50}
        inverted={true}
      />
    </nav>
  )
}

LessonNav.displayName = "LessonNav"

const mapStateToProps = function (state, ownProps) {
  let { selected_group: group, mode, path, next_group } = state.pathStore.state
  const { resource } = state.resourceStore.state

  const isNext = next_group === group.id
  const pathURL = path.url

  ;({ mode } = state.pathStore.state)
  const { setMode } = state.pathStore.action

  const props = _.assign(
    {},
    {
      resource,
      group,
      pathURL,
      isNext,
      mode
    },
    ownProps
  )
  return props
}

const stores = [
  { store: "resource" },
  { store: "navigation" },
  { store: "path" }
]

export default ConnectStores(LessonNav, stores, {}, mapStateToProps)
